import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getSupportedTicketFormat } from '../../../selectors/ticketsAndEvent';
import { CheckoutState } from '../../../state';
import type { TicketDonationSwitcherProps } from './TicketDonationSwitcher';

const _mapStateToProps = (
    state: CheckoutState,
): Pick<TicketDonationSwitcherProps, 'ticketsFormat'> => ({
    ticketsFormat: getSupportedTicketFormat(state),
});

const _mapDispatchToProps = <Action>(_dispatch: Dispatch<Action>) => ({});

export type ConnectedProps = Pick<
    TicketDonationSwitcherProps,
    | keyof ReturnType<typeof _mapStateToProps>
    | keyof ReturnType<typeof _mapDispatchToProps>
>;

export const connectTicketDonationSwitcher = connect(
    _mapStateToProps,
    _mapDispatchToProps,
);
